export default __webpack_public_path__ + "static/media/top_con_cornetas.f06a840e.png";